import React from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const DeliverConfirmDialog = ({
  open,
  onClose,
  orderHistId,
  onFinal,
  orderApprove,
}) => {
  const handleConfirm = async () => {
    try {
      await orderApprove({
        orderHistId,
        orderStatus: 7,
      }).unwrap();

      onFinal();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Confirm Delivery</DialogTitle>

      <DialogContent>
        <Typography>
          Are you sure you want to mark this order as delivered?
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>

        <Button variant="contained" onClick={handleConfirm}>
          Mark Delivered
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeliverConfirmDialog;
